import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetTodosQuery } from "../features/api/apiSlice";
import { filterByColor, filterByStatus } from "../features/filter/filterSlice";

export default function Footer() {
  const { data: todos, isLoading } = useGetTodosQuery();
  const dispatch = useDispatch();
  const { status, colors } = useSelector((state) => state.filter);
  if (isLoading) {
    return "Loading...";
  }
  const todoNumber = todos?.filter((todo) => !todo.completed).length;

  // to handle the status
  const handleStatus = (status) => {
    dispatch(filterByStatus(status));
  };
  const handleColor = (color) => {
    if (colors?.includes(color)) {
      dispatch(filterByColor({ color: color, changeType: "removed" }));
    } else {
      dispatch(filterByColor({ color: color, changeType: "added" }));
    }
  };
  return (
    <div className="mt-4 flex justify-between text-xs text-gray-500">
      <p>
        {todoNumber === 0
          ? "No task"
          : todoNumber === 1
          ? `1 task`
          : `${todoNumber} tasks`}{" "}
        left
      </p>
      <ul className="flex space-x-1 items-center text-xs">
        <li
          className={`cursor-pointer ${status === "All" && "font-bold"}`}
          onClick={() => handleStatus("All")}
        >
          All
        </li>
        <li>|</li>
        <li
          className={`cursor-pointer ${status === "Incomplete" && "font-bold"}`}
          onClick={() => handleStatus("Incomplete")}
        >
          Incomplete
        </li>
        <li>|</li>
        <li
          className={`cursor-pointer ${status === "Complete" && "font-bold"}`}
          onClick={() => handleStatus("Complete")}
        >
          Complete
        </li>
        <li></li>
        <li></li>
        <li
          className={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${
            colors?.includes("green") && "bg-green-500"
          }`}
          onClick={() => handleColor("green")}
        ></li>
        <li
          className={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${
            colors?.includes("red") && "bg-red-500"
          }`}
          onClick={() => handleColor("red")}
        ></li>
        <li
          className={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${
            colors?.includes("yellow") && "bg-yellow-500"
          }`}
          onClick={() => handleColor("yellow")}
        ></li>
      </ul>
    </div>
  );
}
